import { render, staticRenderFns } from "./lightRate.vue?vue&type=template&id=71bb58e4&scoped=true"
import script from "./lightRate.vue?vue&type=script&lang=js"
export * from "./lightRate.vue?vue&type=script&lang=js"
import style0 from "./lightRate.vue?vue&type=style&index=0&id=71bb58e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb58e4",
  null
  
)

export default component.exports